import _ from "lodash";
import { CONTAINS, EQ } from "../../common/reports/reportConstants";

export const debounceCategoryName = _.debounce(
  async (apiFunction, value, setData) => {
    try {
      const payload = {
        orderBy: [{ fieldName: "name", orderType: "asc" }],
        filters: [
          {
            fieldName: "name",
            fieldType: { type: "string", operation: CONTAINS },
            fieldValue: value,
          },
        ],
        includeFields: ["name", "id"],
      };
      const response = await apiFunction(payload);
      if (response.status === "success") {
        const updatedResult = response.result.rows?.map((category) => {
          return {
            id: category.id,
            name: category.name,
          };
        });
        setData(updatedResult);
      }
    } catch (error) {
      console.log(error);
    }
  },
  300
);

export const debounceEntityName = _.debounce(
  async (apiFunction, value, setData) => {
    const payload = {
      orderBy: [{ fieldName: "entityName", orderType: "asc" }],
      filters: [
        {
          fieldName: "entityName",
          fieldType: { type: "string", operation: CONTAINS },
          fieldValue: value,
        },
      ],
      includeFields: ["entityName", "entityId"],
    };

    try {
      const response = await apiFunction(payload);
      if (response.status === "success") {
        const updatedResult = response.result.rows?.map((entity) => {
          return {
            entityId: entity?.entityId,
            entityName: entity?.entityName,
          };
        });
        setData(updatedResult);
      }
    } catch (error) {
      console.log(error);
    }
  },
  300
);

export const debounceCustomerName = _.debounce(
  async (apiFunction, value, setData) => {
    const payload = {
      orderBy: [{ fieldName: "patientName", orderType: "asc" }],
      filters: [
        {
          fieldName: "patientName",
          fieldType: { type: "string", operation: CONTAINS },
          fieldValue: value,
        },
      ],
      includeFields: ["patientName", "patientId"],
    };

    try {
      const response = await apiFunction(payload);
      if (response.status === "success") {
        const updatedResult = response.result.rows?.map((patient) => {
          return {
            patientId: patient?.patientId,
            patientName: patient?.patientName,
          };
        });
        setData(updatedResult);
      }
    } catch (error) {
      console.log(error);
    }
  },
  300
);

export const debounceEntityData = _.debounce(
  async (apiFunction, entityId, setData, setForm) => {
    if (entityId) {
      const payload = {
        orderBy: [{ fieldName: "entityId", orderType: "asc" }],
        filters: [
          {
            fieldName: "entityId",
            fieldType: { type: "string", operation: EQ },
            fieldValue: entityId,
          },
        ],
        includeFields: [
          "entityName",
          "entityId",
          "panNumber",
          "gstinType",
          "gstin",
          "foodLicense",
          "drugLicense",
          "bankId",
          "creditDays",
          "creditLimit",
          "paymentMode",
          "entityBankData.bankName",
          "categoryId",
          "type",
        ],
      };

      try {
        const response = await apiFunction(payload);
        if (response.status === "success") {
          const entity = response.result.rows[0];
          const updatedResult = {
            entityName: entity.entityName || "",
            entityId: entity.entityId,
            panNumber: entity.panNumber || "",
            gstinType: entity.gstinType,
            gstin: entity.gstin || "",
            foodLicense: entity.foodLicense || "",
            drugLicense: entity.drugLicense || "",
            patientBankId: entity.bankId,
            creditDays: entity.creditDays || "",
            creditLimit: entity.creditLimit || "",
            paymentMode: entity.paymentMode,
            bankName: entity?.entityBankData?.bankName,
            patientCategory: entity.categoryId,
            patientType: entity.type,
          };
          delete updatedResult.entityBankData;
          delete updatedResult.bankId;
          delete updatedResult.categoryId;
          setData(() => {
            return updatedResult;
          });
          setForm((prev) => {
            return { ...prev, patientCategory: updatedResult.patientCategory };
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  300
);

export const debounceBankName = _.debounce(
  async (apiFunction, value, setData) => {
    const payload = {
      orderBy: [{ fieldName: "bankName", orderType: "asc" }],
      filters: [
        {
          fieldName: "bankName",
          fieldType: { type: "string", operation: CONTAINS },
          fieldValue: value,
        },
      ],
      includeFields: ["bankName", "bankId", "accountNo"],
    };

    try {
      const response = await apiFunction(payload);
      if (response.status === "success") {
        const updatedResult = response.result.rows?.map((bank) => {
          return {
            bankId: bank?.bankId,
            bankName: bank?.bankName,
            accountNo: bank?.accountNo,
          };
        });
        setData(updatedResult);
      }
    } catch (error) {
      console.log(error);
    }
  },
  300
);
